<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'BankStatement_Title' | translateWF: 'Bank Statement' }}</h1>
      </div>
    </div>

    <div class="grid-12 gap-[2rem]">
      <div class="span-12-4">
        <p-panel [header]="'Filters' | translateWF: 'Filters'" data-variant="filter">
          <p-card>
            <form [formGroup]="filterForm">
              <div class="grid-1 gap-[1rem]">
                <p-floatlabel variant="on">
                  <p-select id="accountId" [options]="bankAccounts()" formControlName="accountId" optionLabel="code" optionValue="id" appendTo="body" class="w-full" />
                  <label for="accountId">{{ 'BankStatement_Account' | translateWF: 'Account' }}</label>
                </p-floatlabel>
                <p-floatlabel variant="on">
                  <p-datepicker id="from" formControlName="from" [showIcon]="true" appendTo="body" class="w-full" />
                  <label for="from">{{ 'BankStatement_From' | translateWF: 'From' }}</label>
                </p-floatlabel>
                <p-floatlabel variant="on">
                  <p-datepicker id="to" formControlName="to" [showIcon]="true" appendTo="body" class="w-full" />
                  <label for="to">{{ 'BankStatement_To' | translateWF: 'To' }}</label>
                </p-floatlabel>
              </div>
            </form>
          </p-card>

          <ng-template pTemplate="footer">
            <p-button [label]="'Apply' | translateWF: 'Apply'" (click)="loadStatement()" />
          </ng-template>
        </p-panel>
      </div>

      <div class="span-12-8">
        <p-panel *ngIf="statement() as st">
          <ng-template pTemplate="header">
            <strong>{{ st.account.code }}</strong> — {{ st.account.name }}
          </ng-template>
          <ng-template pTemplate="icons">
            <div>{{ 'BankStatement_Currency' | translateWF: 'Currency' }}: {{ st.account.currency }}</div>
          </ng-template>
          <p-card data-variant="compact">
            <div class="grid-4 gap-[1rem] mb-[1rem]">
              <div>
                <div class="text-sm">{{ 'BankStatement_Opening' | translateWF: 'Opening' }}</div>
                <div class="text-lg">{{ st.openingBalance | maskedAmount }}</div>
              </div>
              <div>
                <div class="text-sm">{{ 'BankStatement_TotalIn' | translateWF: 'Total In' }}</div>
                <div class="text-lg text-green-600">{{ totalIn() | number: '1.2-2' }}</div>
              </div>
              <div>
                <div class="text-sm">{{ 'BankStatement_TotalOut' | translateWF: 'Total Out' }}</div>
                <div class="text-lg text-red-600">{{ totalOut() | number: '1.2-2' }}</div>
              </div>
              <div>
                <div class="text-sm">{{ 'BankStatement_Closing' | translateWF: 'Closing' }}</div>
                <div class="text-lg">
                  <strong>{{ st.closingBalance | maskedAmount }}</strong>
                </div>
              </div>
            </div>

            <p-table [value]="st.lines" [paginator]="true" [rows]="20" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'BankStatement_Table_Date' | translateWF: 'Date' }}</th>
                  <th>{{ 'BankStatement_Table_Number' | translateWF: 'Number' }}</th>
                  <th>{{ 'BankStatement_Table_Concept' | translateWF: 'Concept' }}</th>
                  <th>{{ 'BankStatement_Table_Counterparty' | translateWF: 'Counterparty' }}</th>
                  <th>{{ 'BankStatement_Table_In' | translateWF: 'In' }}</th>
                  <th>{{ 'BankStatement_Table_Out' | translateWF: 'Out' }}</th>
                  <th>{{ 'BankStatement_Table_Balance' | translateWF: 'Running Balance' }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-line>
                <tr>
                  <td>{{ line.postingDate | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ line.number }}</td>
                  <td>{{ line.concept }}</td>
                  <td>{{ line.counterpartyCode || line.counterpartyName }}</td>
                  <td class="text-green-600">{{ line.direction === 'CREDIT' ? (line.amount | number: '1.2-2') : '' }}</td>
                  <td class="text-red-600">{{ line.direction === 'DEBIT' ? (line.amount | number: '1.2-2') : '' }}</td>
                  <td>{{ line.runningBalance | maskedAmount }}</td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </p-panel>
      </div>
    </div>
  </div>
</main>
